import React from 'react';
import {Link} from "react-router";
import i18n from 'i18n-js';

import Linkr from "./Linkr";
import store, {history} from "../store";

import {VALID_LANGS, VALID_LANG_CODES, api, IP} from "./baseFunctions";
import langs from "./langs/phpIndex";

import "./css/UserMenu.css";

class UserMenu extends React.Component {
  constructor()
  {
    super();
    this.state = {
      "active": {
        key: 0,
        name: 0
      },
      menuPath: window.location.hash,
      departments: [],
    };
  }

  componentDidMount()
  {
    api("POST", {"type": "getDepartments", onlyAll: true}, (d) => {
      if(!d.error)
      {
        this.setState({
          departments: d.data.ids.filter(dep => this.props.rank === -1 || this.props.otherDepartments.includes(dep.id)),
        });
      }
    }, this.props.auth, 1);
  }

  jumpDepartment(dep)
  {
    api("POST", {"type": "fakeLogin", to: dep}, (dat) => {
      if(!dat.error && dat.data)
      {
        store.dispatch({
          type: "UPD_AUTH",
          data: dat.data,
        });
        setTimeout(() => window.location.reload(), 300);
      }
    }, this.props.auth, 1);
  }

	render(){
    const LANG = langs[this.props.lang];
		const menuIcons = {
			"Moduler": "fa fa-bar-chart-o",
			"Superuser": "fa fa-cog",
		};
		const menu = {
			"Moduler": {
				"Oversigt": "/",
        // "Risk assesment": "/ra",
        //"Gammel risk assesment": "/oldRa",
        // "Observationer": "/obs",
        // "Indbakke": "/inbox",
        // "Brugere": "/users",
        // "Notifikationer": "/sub",
        //"Rapporter": "/reports",
        /*"Værktøj": "/obs",
        "Brugere": "/obs",*/
      },
      "Superuser": {
        "Skema grupper": "/groups",
        "Skemaer": "/sheets",
        "Oversættelser": "/locale",
        // "Spørgsmåls ark": "/raSheet",
        // "Observations ark": "/obsSheet",
        "Firmaer": "/firms",
        // "SMS": "/sms",
        // "Server stats": "/serverStats",
        // "System-log": "/log",
        // "Specielle indstillinger": "/settings",
			},
    };
    if((process.env.REACT_APP_MY_ENV || "DEV") === "DEV")
    {
      menu.Superuser.Server = "/server";
    }
    this.props.groups.forEach(group => {
      menu.Moduler[i18n.t(group.name)] = `/reports/${group.id}`;
    });

    menu.Moduler.Brugere = "/users";
    menu.Moduler.Notifikationer = "/sub";
		return (
			<div className="col-md-3 left_col">
        <div className="left_col scroll-view">
          <div className="navbar nav_title" style={{"border": "0"}}>
            <Link to="/" className="site_title">
             <img src={IP + "/logo/" + this.props.logo} className="logo" style={{"width":"92%"}}alt="logo"/>
           </Link>
         </div>

         <div className="clearfix"></div>
         <div id="sidebar-menu" className="main_menu_side hidden-print main_menu">
          <div className="menu_section">
            <ul className="nav side-menu" key={this.state.menuPath}>
            	{
									Object.keys(menuIcons).map((key) => {
										var currIcon = menuIcons[key];
                    if(key === "Superuser" && this.props.rank !== -1)
                    {
                      return (<li key={"menu" + key}></li>);
                    }
										return (
											<li key={"menu" + key} className="active" style={{"marginBottom": "10px"}}><a><i className={currIcon}></i> {LANG[key]} <span className="fa fa-chevron-down"></span></a>
	          						<ul className="nav child_menu" style={{"display": "block"}}>
	          							{
	          								Object.keys(menu[key]).map((name) => {
                              let activeCheck = this.state.menuPath.indexOf(menu[key][name]) !== -1;
                              if(menu[key][name] === "/")
                              {
                                activeCheck = menu[key][name] === this.state.menuPath;
                              }
	          										return (<li key={"point" + key + name} className={activeCheck ? "active" : ""}><Linkr history={history} onClick={() => {
                                  console.log("Going to", menu[key][name]);
                                  this.setState({
                                    menuPath: menu[key][name]
                                  });
                                }} to={menu[key][name]}>{LANG[name] ? LANG[name] : name}</Linkr></li>);
	          								})
	          							}
	          						</ul>
	          					</li>
											);
									})
								}	
             </ul>
          </div>

        </div>

        
        {
          this.state.departments.length > 0 && <div className="sidebar-footer hidden-small secondFooter">
              <select onChange={e => this.jumpDepartment(e.target.value)}>
                {
                  this.state.departments.map(dep => <option key={dep.id} value={dep.id}>{this.props.rank === -1 && `${dep.id}#${dep.firmID} `}{dep.name}</option>)
                }
              </select>
            </div>
        }
        <div className="sidebar-footer hidden-small">
          {
            VALID_LANGS.map((d, i) => <a onClick={() => {
              i18n.locale = VALID_LANG_CODES[i];
              store.dispatch({
                type: 'CHANGE_LANG',
                data: d
              });
            }} style={{cursor: "pointer"}} key={"lang" + d}>
              <span className="">
                {d}
              </span>
            </a>)
          }
          
          <a>
            <span className="glyphicon glyphicon-fullscreen" style={{"visibility":"hidden"}}></span>
          </a>
          <a data-toggle="tooltip" data-placement="top" title="" href="#" onClick={() => {
          	store.dispatch({
          		type: "UPD_AUTH",
          		data: 0
          	});
          	document.body.className = "login";
            // window.location.reload();
          }} data-original-title="Log ud">
            <span className="glyphicon glyphicon-log-out" aria-hidden="true"></span>
          </a>
        </div>
      </div>
    </div>);
	}
}

export default UserMenu;


// WEBPACK FOOTER //
// ./src/components/UserMenu.js